module.exports = __webpack_public_path__ + "static/media/Coursework-class.2614844c.png";